import { render, staticRenderFns } from "./indexDynamic.vue?vue&type=template&id=47e15480"
import script from "./indexDynamic.vue?vue&type=script&lang=js"
export * from "./indexDynamic.vue?vue&type=script&lang=js"
import style0 from "./indexDynamic.vue?vue&type=style&index=0&id=47e15480&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports